var map = {
	"./2gis.svg": "32c3",
	"./angular.svg": "9451",
	"./book.svg": "a337",
	"./bootstrap.svg": "2ea3",
	"./brush.svg": "815f",
	"./calendar.svg": "6bca",
	"./check-success-icon.svg": "2ed1",
	"./figma.svg": "7472",
	"./minus.svg": "f11b",
	"./parachute.svg": "666b",
	"./plus.svg": "6cf9",
	"./react.svg": "f4d6",
	"./rocket.svg": "df02",
	"./speaker.svg": "1535",
	"./star.svg": "0a83",
	"./toolbox.svg": "40d5",
	"./vuejs.svg": "57c1",
	"./yandex.svg": "b02b",
	"./zoon.svg": "04b6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5981";